import Api from "../apis/Api";
import ActionModalMixin from "./ActionModalMixin";

export default {
	data: function () {
		return {
			phpmyadminSsoLoading: false,
			phpmyadminSsoUrl: "",
		};
	},
	mixins: [ActionModalMixin],
	computed: {
		isAppSingleServer() {
			return !!this.$store.state.home.app.single_server?.active;
		},
	},
	methods: {
		async phpmyadminSsoLogin(hostingAccountId, serverType, phpMyAdminSsoHost) {
			if (this.phpmyadminSsoLoading) {
				return;
			}

			this.phpmyadminSsoLoading = true;

			try {
				if (await this.shouldOpenModal(phpMyAdminSsoHost)) {
					const databases = await this.fetchDatabasesForPhpMyAdminSso(hostingAccountId, serverType);

					if (serverType === "plesk" && databases.length === 0) {
						this.$store.dispatch("addAlert", {
							success: false,
							errorMessage: this.$t(
								"message.emptyTable.databases.database.description"
							),
						});
						return;
					}

					const dnsMismatchDetected = await this.getDomainDnsMismatchDetected(phpMyAdminSsoHost);

					if (this.$refs?.phpMyAdminSsoModal?.open) {
						this.$refs.phpMyAdminSsoModal.open({
							hostingAccountId,
							serverType,
							databases,
							dnsMismatchDetected,
						});
						return;
					}
				}

				if (serverType == "plesk") {
					let databases = [];
					await Api.get(`/server-accounts/${hostingAccountId}/mysql/databases`)
						.then((response) => {
							for (let db of response.data.data) {
								databases.push({
									value: db.id,
									label: db.database,
								});
							}
						})
						.catch((error) => {
							this.$store.dispatch("addAlert", {
								success: false,
								errorMessage: Api.getErrorMessage(error),
							});
						});

					if (databases.length === 0) {
						this.$store.dispatch("addAlert", {
							success: false,
							errorMessage: this.$t(
								"message.emptyTable.databases.database.description"
							),
						});
						return;
					}

					if (databases.length === 1) {
						await this.phpmyadminSsoLoginToDatabase(
							databases[0].value,
							hostingAccountId
						);
						return;
					}

					this.showChooseDatabaseModal(databases, hostingAccountId);
					return;
				}

				try {
					const response = await Api.post(
						`/server-accounts/${hostingAccountId}/mysql/phpmyadmin-sso-url`
					);
					window.open(response.data.data.url);
				} catch (error) {
					this.$store.dispatch("addAlert", {
						success: false,
						errorMessage: Api.getErrorMessage(error),
					});
				}
			} finally {
				this.phpmyadminSsoLoading = false;
			}
		},

		phpmyadminSsoLoginToDatabase(id, hostingAccountId) {
			return Api.post(`/server-accounts/${hostingAccountId}/mysql/phpmyadmin-sso-url`, {
				database_id: id,
			}).then((response) => {
				window.open(response.data.data.url);
			}).catch((error) => {
				this.$store.dispatch("addAlert", {
					success: false,
					errorMessage: Api.getErrorMessage(error),
				});
			});
		},

		showChooseDatabaseModal(options, hostingAccountId) {
			this.resetModal();
			this.modalOptions.title = "PHPMyAdmin";
			this.modalOptions.color = 'info'
			this.modalOptions.persistent = true;
			this.modalOptions.formValues = {}

			this.modalOptions.buttons.unshift({
				label: this.$t("button.login.phpmyadmin"),
				color: 'primary',
				onclick: async modal => {
					this.modalOptions.submitting = true;
					await this.phpmyadminSsoLoginToDatabase(modal.formValues.database, hostingAccountId);
					this.modalOptions.submitting = false;
					this.modalOptions.open = false;
				}
			});

			this.modalOptions.formValues.database = options[0].value;
			this.modalOptions.formFields = [
				{
					label: this.$t("Database"),
					name: "database",
					type: "select",
					options: options,
				},
			];
			this.modalOptions.submitting = false;
			this.modalOptions.open = true;
		},

		async shouldOpenModal(phpMyAdminSsoHost) {
			const dnsMismatchDetected = await this.getDomainDnsMismatchDetected(phpMyAdminSsoHost);

			return dnsMismatchDetected &&
				(this.isAppSingleServer ||
					this.$store.state.home.app.integrations
						.preview_site_provider_enabled);
		},

		async getDomainDnsMismatchDetected(domain) {
			if (!domain) {
				return true;
			}
			try {
				const resolvedIp = await Api.dns().resolveARecord(domain);
				if (resolvedIp) {
					return false;
				}
				if (domain.startsWith("www.")) {
					const resolvedIpNoWww = await Api.dns().resolveARecord(domain.slice(4));
					return !resolvedIpNoWww;
				}
				return true;
			} catch (e) {
				return true;
			}
		},

		async fetchDatabasesForPhpMyAdminSso(hostingAccountId, serverType) {
			if (serverType !== "plesk") {
				return [];
			}
			try {
				const response = await Api.get(
					`/server-accounts/${hostingAccountId}/mysql/databases`
				);
				return (response?.data?.data ?? []).map((db) => ({
					value: db.id,
					label: db.database,
				}));
			} catch (error) {
				this.$store.dispatch("addAlert", {
					success: false,
					errorMessage: Api.getErrorMessage(error),
				});
				return [];
			}
		},
	},
}
